class Logger {
  // level @params 0 全部 1 info  2 warn 3 error
  constructor (level) {
    this.level = level
  }

  debugger () {
    this.level === 0 && console.log(`%c ${JSON.stringify(arguments[0])} ${(arguments[1] && JSON.stringify(arguments[1])) || ''}`, 'background:#222;color:#fff;')
  }

  info (log) {
    (this.level === 0 || this.level < 2) && console.log(`%c ${typeof log === 'string' ? log : JSON.stringify(log)}`, 'color:#009933')
  }

  warn (log) {
    (this.level === 0 || this.level < 3) && console.warn(log)
  }

  error (message, error) {
    (this.level === 0 || this.level < 4) && console.error(message, error)
  }
}

export default Logger
